import './application';
import '../utils/bugsnag';
import '../apps/trail_overview_map/main.ts';
import '../apps/download_modal/main.ts';
import '../utils/share_buttons';
import '../utils/lightbox';
import '../utils/sale';
import '../apps/flyover_preview/main.ts';
import '../apps/on_boarding/main';

console.log("Hello from the Hiiker map! 🌍");
